import { Component, OnInit } from '@angular/core';
import { RemoteAssessment } from 'app/model/remote-assessment';
import { PS } from 'app/model/ps';
import { NgWizardService } from 'ng-wizard';
import { ContextService } from 'app/services/context.service';

interface ServicesByLevel {
  levelId: number;
  levelLabel: string;
  services: PS[];
}

@Component({
  selector: 'app-professional-services',
  templateUrl: './professional-services.component.html',
  styleUrls: ['./professional-services.component.css']
})
export class ProfessionalServicesComponent implements OnInit {
  isStarted: boolean = false;
  groupedProfessionalServices: ServicesByLevel[] = [];
  private psInitialised = false;
  isPostStepThreeReadOnlyWorkflow = false;

  remoteAssessment: RemoteAssessment;
  constructor(private ngWizardService: NgWizardService, private context: ContextService) {
    this.context.remoteAssessment.subscribe(ra => {
      this.remoteAssessment = ra;
      this.isStarted = !!this.remoteAssessment?.isAssessmentStartDateContain;

      if (!this.psInitialised) {
        this.psInitialised = true;
      this.remoteAssessment.professionalServices.forEach(ps => {
        var index = this.remoteAssessment.assessmentPS.findIndex(x => x.serviceName.id == ps.id);
        if (index != -1) {
          if (this.remoteAssessment.assessmentPS[index].status.id == "0") {
            ps.selected = true;
            ps.wasVisibleInStep1 = true;
              ps.wasEverSelected = true;
              ps.selectedAtNavigation = true;
            if(!this.remoteAssessment.assessmentPS[index].expandedService)
            {
              ps.originallySelected = true;
            }

            
          }
          ps.lastModifiedByPortalUser = this.remoteAssessment.assessmentPS[index].lastModifiedByPortalUser;
          ps.lastModifiedOnPortalUser = this.remoteAssessment.assessmentPS[index].lastModifiedOnPortalUser;
        }
      });

      this.context.updateContextRA(this.remoteAssessment);
      } // end psInitialised guard

      this.groupedProfessionalServices = this.buildGroupedProfessionalServices(this.remoteAssessment.professionalServices || []);
    });

    this.context.postStepThreeReadOnlyWorkflow.subscribe(enabled => {
      this.isPostStepThreeReadOnlyWorkflow = enabled === true;
    });
  }

  ngOnInit(): void {

  }

  CheckboxDisabled(ps: PS) {
    if ((this.remoteAssessment.assessment.assessmentType.id === '806390002' || this.remoteAssessment.assessment.assessmentType.id === '806390003' || this.remoteAssessment.assessment.assessmentType.id === '806390005') && ps.name === 'My Health Record') {
      return true;
    }

    return this.remoteAssessment.readOnly
      || this.isPostStepThreeReadOnlyWorkflow
      || this.remoteAssessment.assessment.assessmentType.id === '806390001'
      || ((this.remoteAssessment.assessment.assessmentType.id === '806390002' || this.remoteAssessment.assessment.assessmentType.id === '806390003' || this.remoteAssessment.assessment.assessmentType.id === '806390005') && ps.originallySelected);
  }

  hasSelectedServices(): boolean {
    return (this.remoteAssessment?.professionalServices || []).some(ps => ps.selected === true);
  }

  isNoServicesOfferedVisible(): boolean {
    if (!this.remoteAssessment?.assessment?.assessmentType?.id) {
      return false;
    }

    const assessmentTypeId = String(this.remoteAssessment.assessment.assessmentType.id);
    const isTargetAssessmentType = assessmentTypeId === '806390003' || assessmentTypeId === '806390004';

    return isTargetAssessmentType && !this.hasSelectedServices();
  }

  hasAccreditedServiceInLevel(group: ServicesByLevel): boolean {
    const levelId = Number(group?.levelId);
    if (isNaN(levelId)) {
      return false;
    }

    return (this.remoteAssessment?.pharmacyDetails?.servicelevel || []).some(level => Number(level?.value) === levelId);
  }


  nextStep() {
    // Snapshot selection state at the exact moment the user navigates to Step 2.
    // isRemovedService in Step 2 relies on this flag — NOT on wasEverSelected — to
    // avoid false-positive "Removed Service" badges caused by timing/lifecycle gaps.
    (this.remoteAssessment?.professionalServices || []).forEach(ps => {
        // Additive only: once a service has been confirmed as selected at any navigation,
        // it stays true. This ensures unchecks made in Step 1 before pressing Continue
        // are still detected as removals in Step 2.
        if (ps.selected === true) {
          ps.selectedAtNavigation = true;
        }
    });
    this.context.updateContextRA(this.remoteAssessment);
    this.ngWizardService.next();
  }






  previousStep() {
    this.ngWizardService.previous();
  }

  checkboxChanged(_ps: PS) {
      if (_ps.selected === true) {
        _ps.wasEverSelected = true;
      }
    } // Added missing closing brace for checkboxChanged method

  getDate(date) {
    if (date) {
      var currentDate = new Date(parseInt(date.substr(6)));
      return currentDate;
    }

  }

  private buildGroupedProfessionalServices(services: PS[]): ServicesByLevel[] {
    const grouped = new Map<number, PS[]>();

    services.forEach(ps => {
      const levelId = ps?.servicelevel?.id ?? 0;
      const existing = grouped.get(levelId) || [];
      existing.push(ps);
      grouped.set(levelId, existing);
    });

    return Array.from(grouped.entries())
      .sort((a, b) => a[0] - b[0])
      .map(([levelId, levelServices]) => ({
        levelId,
        levelLabel: this.formatLevelLabel(levelId, levelServices[0]?.servicelevelDisplayName),
        services: levelServices
      }));
  }

  private formatLevelLabel(levelId: number, displayName?: string): string {
    if (!(levelId > 0)) {
      return displayName || 'Level Unspecified';
    }

    const rawName = (displayName || '').trim();
    const nameWithoutSuffix = rawName.replace(/\s*\(Level\s*\d+\)\s*$/i, '');
    const nameWithoutPrefix = nameWithoutSuffix.replace(/^Level\s*\d+\s*[–-]\s*/i, '');
    const normalizedName = (nameWithoutPrefix || rawName).trim();

    return normalizedName || rawName;
  }

  private mapServiceLevelToDisplayNumber(levelId: number): number {
    const levelMap: Record<number, number> = {
      806460000: 1,
      806460001: 2,
      806460002: 3,
      806460003: 4
    };

    return levelMap[levelId] ?? levelId;
  }
}
